export const Note = ({t}) => (
  <>
    <div className="fs-10" style={{ color: "#555555" }}>
      <strong style={{ fontWeight: "600" }}>{t("หมายเหตุ")}: </strong>{" "}
      <span>
        {t("ตรวจสอบข้อมูลผู้โอนและผู้รับโอน")}
        {" "}
        <b>
          <u style={{ color: "#eb3939ff" }}>{t("ต้องตรงกับข้อมูลที่มีในระบบ")}</u>
        </b>
      </span>
      <br />
      <p>
        {t("กรณีเกิดข้อผิดพลาด ระบบจะแจ้งข้อความให้ทราบถึงสาเหตุที่ไม่ผ่านการตรวจสอบ (ด้านบน)")} <b>{t("กรุณาอ่าน!")}</b>{" "}
      </p>
      <b>{t("ข้อความแสดงข้อผิดพลาดที่พบบ่อย ได้แก่:")}</b>
      <br />
      <ul style={{ paddingInlineStart: "20px" }}>
        <li>
          <b>{t("ข้อมูลบัญชีต้นทางไม่ตรงกับข้อมูลลูกค้า (NOT_MATCH)")}</b> <br />{" "}
          {t("กรุณาตรวจสอบข้อมูลผู้โอนให้ถูกต้อง")}
          {t("อาจจะใช้บัญชีอื่นที่ไม่ใช่บัญชีที่ลงทะเบียนไว้")}
        </li>
        <li>
          <b>{t("ไม่พบบัญชีปลายทางในระบบ (NOT_MATCH)")}</b> <br />
          {t("กรุณาตรวจสอบข้อมูลผู้รับโอนให้ถูกต้อง หรือบัญชีปลายทางยังไม่ได้ลงทะเบียนกับทางเรา")}
          
        </li>
        <li>
          <b>{t("พบรายการฝากเงินซ้ำ (DUPLICATED)")}</b> <br />
          {t("ระบบตรวจสอบพบว่ามีรายการฝากเงินสำเร็จแล้วในระบบ กรุณาตรวจสอบที่รายการฝาก")}
          
        </li>
      </ul>
    </div>
  </>
);
